<script setup lang="ts">
import type { IRateResponse } from '~/components/widget/rates'
import NbkrRateChart from '~/components/ui/nbkr-rate-chart/NbkrRateChart.vue'
import { ref, computed } from 'vue'

const props = defineProps<{
  currency: string
}>()

const config = useRuntimeConfig()
const currencyStore = useCurrencyStore()
const { list } = storeToRefs(currencyStore)

const selectedCurrency = ref<string>(props.currency || 'usd')

const url = computed(() => {
  return `${config.public.baseApiUrl}/rates/central/${selectedCurrency.value}`
})

const { data: rates, pending } = useFetch<IRateResponse>(url, {
  key: `rates-charts-central-${selectedCurrency.value}`,
  watch: [selectedCurrency],
  server: false
})

const currencyTitle = computed(() => {
  return list.value.find((i) => i.code === props.currency.toUpperCase())?.title || ''
})

const chartData = computed(() => rates.value?.central || null)
</script>

<template>
  <NbkrRateChart
    :currency="props.currency"
    :currency-title="currencyTitle"
    :data="chartData"
    :loading="pending"
  />
</template>
